<template>
  <router-view/>
</template>

<style lang="less">
*{
  margin: 0;
  padding: 0;
  font-family:Arial, Helvetica, sans-serif;
}
#app {
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
}
</style>
